import { IColorByValueAttributeMap } from 'app/services/api/colorByValue'

const DATA_QUALITY_SUFFIX = 'Dq'

const orderDataQualityAttributes = (
  attributes: IColorByValueAttributeMap[]
): IColorByValueAttributeMap[] => {
  const attributeCodes = new Set(
    attributes.map((attribute) => attribute.attributeCode)
  )

  const dataQualityByMainCode = new Map<string, IColorByValueAttributeMap[]>()

  const pairedDataQualityAttributes = new Set<IColorByValueAttributeMap>()

  for (const attribute of attributes) {
    if (!attribute.attributeCode.endsWith(DATA_QUALITY_SUFFIX)) {
      continue
    }

    const mainCode = attribute.attributeCode.slice(
      0,
      -DATA_QUALITY_SUFFIX.length
    )

    if (attributeCodes.has(mainCode)) {
      const pairedAttributes = dataQualityByMainCode.get(mainCode) ?? []

      pairedAttributes.push(attribute)
      dataQualityByMainCode.set(mainCode, pairedAttributes)
      pairedDataQualityAttributes.add(attribute)
    }
  }

  const orderedAttributes: IColorByValueAttributeMap[] = []

  for (const attribute of attributes) {
    if (pairedDataQualityAttributes.has(attribute)) {
      continue
    }

    orderedAttributes.push(attribute)

    const dataQualityAttributes = dataQualityByMainCode.get(
      attribute.attributeCode
    )

    if (dataQualityAttributes != null) {
      orderedAttributes.push(...dataQualityAttributes)
      dataQualityByMainCode.delete(attribute.attributeCode)
    }
  }

  return orderedAttributes
}

export { orderDataQualityAttributes }
